import { createEnumParam, NumericArrayParam, StringParam, withDefault } from 'use-query-params';
import { RedditPostsOrderBy } from './types';
import type { PostType, SortBy, TimeRange } from './types';

export const DEFAULT_TIME_RANGE: TimeRange = 'today';
export const DEFAULT_SORT_BY: SortBy = RedditPostsOrderBy.UpvotesCount;
export const DEFAULT_POST_TYPE: PostType = 'all';
export const DEFAULT_KEYWORD_IDS: number[] = [];
export const PAGE_SIZE = 50;

export const TIME_RANGE_PARAM = withDefault(
  createEnumParam<TimeRange>(['today', 'last_7_days', 'last_30_days']),
  DEFAULT_TIME_RANGE
);

export const SORT_BY_PARAM = withDefault(
  createEnumParam<SortBy>([
    RedditPostsOrderBy.UpvotesCount,
    RedditPostsOrderBy.CommentsCount,
    RedditPostsOrderBy.PostedAt,
    RedditPostsOrderBy.TrendScore,
  ]),
  DEFAULT_SORT_BY
);

export const POST_TYPE_PARAM = withDefault(
  createEnumParam<PostType>(['all', 'text', 'visual']),
  DEFAULT_POST_TYPE
);

export const KEYWORDS_PARAM = withDefault(NumericArrayParam, DEFAULT_KEYWORD_IDS);

export const REDDIT_ID_PARAM = StringParam;
